
export default {
  openCustomerDialog (state, dialogState) {
    console.log('customer dialog')
    state.customerDialog = { ...state.customerDialog, ...dialogState }
    if(state.customerDialog.fields.Master_Id !== 'None' &&  state.customerDialog.fields.Master_Id !== null){
      state.customerDialog.isSingleMp = true
    } else {
      state.customerDialog.isSingleMp = false


    }
  },
  clearCustomerDialog (state) {
    state.customerDialog = { ...state.customerDialog,
      type: 'new', // ie new or edit?
      show: false,
      saving: false,
      showResponse: false,
      responseMessage: null,
      responseType: null,
      submitHandler: null,
      submitLabel: 'Create',
      cancelLabel: 'Cancel',
      isSingleMp: false,
      fields: {
        Customer_Name: null,
        Customer_Region: null,
        Customer_Alias: null,
        Master_Id: null
      }
    }
  },
  setLoadingRequest: (state, loading) => {
    state.loadingRequest = loading
  },
  setEmailAuditList(state, data) {
    state.emailAuditList = data
  },
  setSavingResponse (state, data) {
    state.customerDialog = { ...state.customerDialog, ...data }
  },
  setNewCustomerSaving (state, saving) {
    state.customerDialog.saving = saving
  },
  setCustomerListLoading (state, loading) {
    state.customerListLoading = loading
  },
  setCustomerList (state, customers) {
    state.customers = customers
  },
  setInitMPayer (state, data) {
    state.mPayers = data
  },
  openMPayerDialog (state, dialogState) {
    state.mpDialog = { ...state.mpDialog, ...dialogState }
  },
  addRecordToCustomerList (state, customer) {
    state.customers.push({
      Customer_Id: customer.Customer_Id,
      Cust_Region: `${customer.Customer_Name} - ${customer.Customer_Region}`,
      Customer_Name: customer.Customer_Name,
      Customer_Region: customer.Customer_Region,
      Customer_Alias: customer.Customer_Alias,
      Master_Id: customer.Master_Id
    })
  },
  updateCustomerList (state, customer) {
    let recordToBeUpdatedIndex = state.customers.findIndex(record => record.Customer_Id === customer.Customer_Id)
    if (recordToBeUpdatedIndex !== -1) {
      state.customers.splice(recordToBeUpdatedIndex, 1, {
        Customer_Id: customer.Customer_Id,
        Cust_Region: `${customer.Customer_Name} - ${customer.Customer_Region}`,
        Customer_Name: customer.Customer_Name,
        Customer_Region: customer.Customer_Region,
        Customer_Alias: customer.Customer_Alias,
        Master_Id: customer.Master_Id
      })
      state.accountDialog.fields.Customer_Name = state.customers[recordToBeUpdatedIndex].Customer_Name
    }
  },
  deleteRecordOnCustomerList (state, id) {
    let recordToBeDeleted = state.customers.findIndex(record => record.Customer_Id === id)
    if (recordToBeDeleted !== -1) {
      state.customers.splice(recordToBeDeleted, 1)
    }
  },
  updateCustomer (state, id, context) {
    let customer = state.customers.find(record => record.Customer_Id === id)
    state.accountDialog = {
      ...state.accountDialog,
      fields: {
        ...state.accountDialog.fields,
        Cust_Region: `${customer.Customer_Name} ${customer.Customer_Region}`,
        Customer_Id: customer.Customer_Id,
        Customer_Name: customer.Customer_Name,
        Customer_Region: customer.Customer_Region,
        Customer_Alias: customer.Customer_Alias
      }
    }
  },
  assignNewCustomerToAccount (state, customer) {
    state.accountDialog = {
      ...state.accountDialog,
      fields: {
        ...state.accountDialog.fields,
        Cust_Region: `${customer.Customer_Name} ${customer.Customer_Region}`,
        Customer_Id: customer.Customer_Id,
        Customer_Name: customer.Customer_Name,
        Customer_Region: customer.Customer_Region,
        Customer_Alias: customer.Customer_Alias
      }
    }
  },
  
  assignPODId(state, podId) {
    state.accountDialog.fields = {POD_Id: podId, ...state.accountDialog.fields}
  },

  openAccountDialog (state, data) {
    state.accountDialog = { ...state.accountDialog, ...data }
  },
  openMasterPayerDialog (state, data) {
    state.mpDialog = { ...state.mpDialog, ...data }
  },
  updateMasterPayerList: (state, record) => {
    let recordIndex = state.mPayers.findIndex(account => account.Master_Id === record.Master_Id)
    if (recordIndex !== -1) {

      let syncConfig = JSON.stringify(record.Sync_Config)
      let updatedRecord = {
        ...state.mPayers[recordIndex],
        ...record,
        Sync_Config: syncConfig
      }
      
      state.mPayers.splice(recordIndex, 1, updatedRecord)
    }
  },
  openClonedAccount (state, data) {
    state.accountDialog = { ...state.accountDialog, ...data }
  },
  savingAccount (state, data) {
    state.accountDialog = { ...state.accountDialog, saving: data }
  },

  savingAWSLaunchDate (state, saving) {
    state.accountDialog = { ...state.accountDialog, savingAWSLaunchDate: saving }
  },

  savingDateSentToAWS (state, saving) {
    state.accountDialog = { ...state.accountDialog, savingDateSentToAWS: saving }
  },

  setCustomerSearchLoading (state, data) {
    state.accountDialog = { ...state.accountDialog, searchLoading: data }
  },
  setCustomerSearchList (state, data) {
    state.accountDialog = { ...state.accountDialog, customerList: data }
  },
  setAccountIdExistLoading (state, loading) {
    if (loading) {
      state.accountDialog = {
        ...state.accountDialog,
        accountIdExist: false,
        accountIdExistLoading: loading,
        accountIdExistError: false,
        accountIdExistErrorMessages: [],
        accountIdExistSuccess: false,
        accountIdExistSuccessMessages: []
      }
    } else {
      state.accountDialog = {
        ...state.accountDialog,
        accountIdExistLoading: loading
      }
    }
  },
  setAccountIdAvailabilityMessage (state, data) {
    if (data.type === 'success') {
      state.accountDialog = {
        ...state.accountDialog,
        accountIdExist: true,
        accountIdExistSuccess: true,
        accountIdExistSuccessMessages: [data.message],
        accountIdExistError: false,
        accountIdExistErrorMessages: []
      }
    } else {
      state.accountDialog = {
        ...state.accountDialog,
        accountIdExist: false,
        accountIdExistSuccess: false,
        accountIdExistSuccessMessages: [],
        accountIdExistError: true,
        accountIdExistErrorMessages: [data.message]
      }
    }
  },

  setAceOppNumAvailabilityMessage (state, data) {
    if (data.type === 'success') {
      state.accountDialog = {
        ...state.accountDialog,
        opportunityNumberExist: true,
        opportunityNumberExistSuccess: true,
        opportunityNumberExistSuccessMessages: [data.message],
        opportunityNumberExistError: false,
        opportunityNumberExistErrorMessages: [],
        isOpportunityNumberExist: data.isExist
      }
    } else {
      state.accountDialog = {
        ...state.accountDialog,
        opportunityNumberExist: false,
        opportunityNumberExistSuccess: false,
        opportunityNumberExistSuccessMessages: [],
        opportunityNumberExistError: true,
        opportunityNumberExistErrorMessages: [data.message],
        isOpportunityNumberExist: data.isExist
      }
    }
  },

  setAceOppNumExistLoading (state, loading) {
    if (loading) {
      state.accountDialog = {
        ...state.accountDialog,
        opportunityNumberExist: false,
        opportunityNumberExistLoading: loading,
        opportunityNumberExistError: false,
        opportunityNumberExistErrorMessages: [],
        opportunityNumberExistSuccess: false,
        opportunityNumberExistSuccessMessages: []
      }
    } else {
      state.accountDialog = {
        ...state.accountDialog,
        opportunityNumberExistLoading: loading
      }
    }
  },

  clearAceOppNumChecking (state) {
    state.accountDialog = {
      ...state.accountDialog,
      opportunityNumberExist: false,
      opportunityNumberExistLoading: false,
      opportunityNumberExistError: false,
      opportunityNumberExistErrorMessages: [],
      opportunityNumberExistSuccess: false,
      opportunityNumberExistSuccessMessages: []
    }
  },

  setMpIdExistLoading (state, loading) {
    if (loading) {
      state.accountDialog = {
        ...state.accountDialog,
        mpIdExist: false,
        mpIdExistLoading: loading,
        mpIdExistError: false,
        mpIdExistErrorMessages: [],
        mpIdExistSuccess: false,
        mpIdExistSuccessMessages: []
      }
    } else {
      state.accountDialog = {
        ...state.accountDialog,
        mpIdExistLoading: loading
      }
    }
  },
  setMpIdAvailabilityMessage (state, data) {
    if (data.type === 'success') {
      state.accountDialog = {
        ...state.accountDialog,
        mpIdExist: true,
        mpIdExistSuccess: true,
        mpIdExistSuccessMessages: [data.message],
        mpIdExistError: false,
        mpIdExistErrorMessages: []
      }
    } else {
      state.accountDialog = {
        ...state.accountDialog,
        mpIdExist: false,
        mpIdExistSuccess: false,
        mpIdExistSuccessMessages: [],
        mpIdExistError: true,
        mpIdExistErrorMessages: [data.message]
      }
    }
  },
  setAccountDialogResponse (state, data) {
    state.accountDialog = {
      ...state.accountDialog,
      saving: false,
      saved: true,
      cancelLabel: 'Close',
      alertType: data.alertType,
      alertMessage: data.alertMessage
    }
  },
  resetAccountDialog (state) {
    state.accountDialog = {
      search: null,
      show: false,
      showSelectCustomer: true,
      selectedCustomer: false,
      continueEnabled: false,
      customers: [],
      customerList: [],
      saving: false,
      saved: false,
      submitHandler: null,
      closeHandler: null,
      submitLabel: 'Submit',
      cancelLabel: 'Cancel',
      alertType: false,
      alertMessage: false,
      step: 0,
      valid: true,
      accountIdExist: false,
      mpIdExist: false,
      accountIdExistError: false,
      accountIdExistErrorMessages: [],
      accountIdExistSuccess: false,
      accountIdExistSuccessMessages: [],

      OppRegIdExistError: false,
      OppRegIdExistErrorMessage:[],
      OppRegIdExistSuccess:false,
      OppRegIdExistSuccessMessage:[],
      OppregIdStatus: true,
      OppRegIdExistLoading:false,
      OppregIdValidated: false,
  
      isWorkload: false,
      workloads: [],

      dates: {
        date_onboarded: false,
        last_date_validate: false,
        date_requested_change: false,
        wbs_expiration_date: false,
        iwo_expiration_date: false,
        end_date: false
      },
      fields: {
        Acct_Restricted: null,
        Acct_ID: null,
        Project_Id:null,
        Acct_name: null,
        Acct_DL: null,
        Date_onboarded: null,
        Last_Date_Validated: null,
        Date_Suspended: null,
        Date_Requested_change: null,
        Master_Id: null,
        MP_ID: null,
        Previous_MP_ID: null,
        Managed_Svc: null,
        Acct_status: 'New',
        AWS_Support_Type: null,
        Is_MP: null,
        Acct_Description: null,
        Acct_Alias_Group:'None',
        // unique agreements
        DXC_discount: null,
        DXC_uplift: null,
        Client_discount: null,
        Client_uplift: null,
        Contract_description: null,
        Account_notes: null,
        // financial
        WBS_code: null,
        WBS_expiration_date: null,
        IWO_Reqd: null,
        IWO_Code: null,
        IWO_expiration_date: null,
        // expiration
        Credit_amount: null,
        Account_expire_on_credits: null,
        End_date: null,
        Account_expire_on_end_date: null,
        R_Code: null,
        Notification_List: [],
        IAM_Users: [],
        Financial_Owner:[],
        GovCloud_Resource_Account: null
      }
    }
  },
  setOppIdExistsLoading (state, data) {
    state.accountDialog.OppRegIdExistLoading = data
  },
  setOppRegIdAvailabilityMessage(state, data) {
    if(data.type === 'success'){
    state.accountDialog = {
      ...state.accountDialog,
      OppregIdValidated:true,
      OppRegIdExistError: false, 
      OppRegIdExistErrorMessage:[], 
      OppRegIdExistSuccess: true, 
      OppRegIdExistSuccessMessage: [data.message],
      isWorkload: data.isWorkload,
    }
  } else { 
    state.accountDialog = {
      ...state.accountDialog, 
      OppregIdValidated:false,
      OppRegIdExistError: true, 
      OppRegIdExistErrorMessage:[data.message], 
      OppRegIdExistSuccess: false, 
      OppRegIdExistSuccessMessage: [],
      isWorkload: data.isWorkload
    }
  }
  },

  setOppregWorkloads (state, workloads){
    console.log('****** you are here *******')
    console.log(workloads)
    console.log('***************************')
    state.accountDialog.workloads = workloads
  },

  setProjectId (state, id) {
    state.accountDialog.fields.Project_Id = id
  },
  clearValidationErrors (state) {
    // this.$validator.reset()
    vm.$validator.errors.clear()
    vm.$validator.resume()
  },
  setNewCustomerData (state, id) {
    let customer = state.customers.find(record => record.Customer_Id == id)
    state.accountDialog.fields.Customer_Id = customer.Customer_Id
    state.accountDialog.fields.Customer_Name = customer.Customer_Name
    state.accountDialog.fields.Customer_Region = customer.Customer_Region
  },
  updateDateSuspended (state, date) {
    state.accountDialog.fields.Date_Suspended = date
  },
  setCheckingCustomerLoading (state, loading) {
    state.accountDialog.searchLoading = loading
  },
  setMassUpdateLastDateValidated (state, data) {
    state.logRecord = { ...data }
  },

  setMpIdValidation (state, data) {
    state.mpDialog = {
      ...state.mpDialog,
      mpIdValidation: { ...data }
    }
  },

  setNewMasterPayerSaving (state, saving) {
    console.log('------ setNewMasterPayerSaving ', saving)
    state.mpDialog.saving = saving
  },

  setMpSavingResponse (state, data) {
    console.log('------- setMpSavingResponse -------')
    console.log(data)
    state.mpDialog = { ...state.mpDialog, ...data }
  },

  addRecordToMasterPayerList (state, mp) {
    state.masterPayers.push({
      Master_Id: mp.Master_Id,
      MP_ID: mp.MP_ID,
      Agreement: mp.Agreement,
      AWS_Support_Type: mp.AWS_Support_Type,
      Type: mp.Type,
      MP_discount: mp.MP_discount,
      MP_uplift: mp.MP_uplift,
      MP_Business_Rules: mp.MP_Business_Rules,
      MP_features: mp.MP_features,
      MP_Type: mp.MP_Type
    })
  },

  resetMasterPayerDialog (state) {
    state.mpDialog = {
      type: 'new',
      show: false,
      submitHandler: null,
      submitLabel: 'Create',
      mpIdValidation: {
        isValidated: false,
        isLoading: false,
        error: false,
        errorMessage: '',
        success: false,
        successMessage: ''
      },
      fields: {
        Master_Id: null,
        MP_ID: null,
        Agreement: null,
        AWS_Support_Type: null,
        Type: null,
        MP_discount: null,
        MP_uplift: null,
        MP_Business_Rules: null,
        MP_features: null,
        MP_Type: null,
        Sync_Config: {
          Customer_Id: null,
          Managed_Services: null,
          WBS_code: null,
          IWO_code: null
        },
        Grandfathered: null,
        CT_Log_Usage: null
      }
    }
  },
  // Financial Administration: Monthly Cross Charge
  openFinanceMonthlyCrossDialog (state, data) {
    state.financeDialog = { ...state.financeDialog, ...data }
  },
  savingFinanceAccount (state, data) {
    state.financeDialog = { ...state.financeDialog, saving: data }
  },
  setFinanceSavingResponse (state, data) {
    state.financeDialog = { ...state.financeDialog, ...data }
  },
  setSFDCOppStatus(state, oppStatus){
      let externalOppStatus = oppStatus 
      state.financeDialog.fields.SFDC_Opp_Status = oppStatus
  },
  setSFDCValidating (state, loading){
    state.financeDialog.sfdcValidation.validating = loading
  },
  setSFDCValidationResponse(state, response){
    state.financeDialog.sfdcValidation = {
      validating: false, 
      validated: response.validated,
      validationMessage: response.msg
    }

  },
  resetFinanceDialog (state) {
    state.financeDialog = {
      type: 'new', // ie new or edit?
      show: false,
      saving: false,
      saved: false,
      showResponse: false,
      responseMessage: null,
      responseType: null,
      submitHandler: null,
      submitLabel: 'Create',
      cancelLabel: 'Cancel',
      sfdcValidation: {
        validating: false,
        validated: false,
        validationMessage: ''
      },
      fields: {
        Id: null,
        // Financial_Period_Id:null,
        PayerAccountId: null,
        LinkedAccountId: null,
        LinkedAccountName: null,
        Service_Period: null,
        Service_Product: null,
        CloudCheckr_Cost: null,
        Additional_Discount: null,
        Uplift: null,
        Credit_Backbill: null,
        Tota_Costs_to_Allocate: null,
        Estimated_Monthly_Revenue: null,
        Estimated_Twelve_Month_Revenue: null,
        Can_Allocate: null,
        WBS: null,
        WBS_End_Date: null,
        IWO_Number: null,
        Originating_Org_WBS: null,
        Cost_Center: null,
        Client_Name: null,
        Horizon_Client_Name: null,
        Revenue_Missing_from_Horizon: null,
        Region: null,
        Account_Type: null,
        Major_Offering_Code: null,
        Major_Offering_Name: null,
        SFDC_Opp_ID: null,
        SFDC_Opp_Status: null,
        AWS_on_Opp: null,
        Financial_System: null,
        CR_Redeemed_from_AWS: null,
        CR_Used: null,
        CR_Remaining: null,
        Exceptions: null,
        AWS_Discount: null,
        DXC_Discount: null,
        Contract: null,
        Notes: null,
        Galaxy_Service_Level: null
      }
    }
  },
  showLinkedAccounts (state, data) {
    state.linkedAccountForm = {
      ...state.linkedAccountForm,
      show: true,
      id: data.id,
      mpid: data.mpid,
      accounts: data.accounts
    }
  },
  resetLinkedAccounts (state) {
    state.linkedAccountForm = {
      show: false,
      id: null,
      mpid: null,
      accounts: [],
      accountHeaders: [
        {
          sortable: true,
          text: 'ID',
          value: 'Acct_ID',
          align: 'left'
        },
        {
          sortable: true,
          text: 'Account Name',
          value: 'Acct_name',
          align: 'left'
        }
      ],
      // pagination: {
      //   descending: true,
      //   page: 1,
      //   rowsPerPage: 10,
      //   totalItems: 0
      // }
    }
  },
  setLinkedAccounts (state, accounts) {
    state.linkedAccountForm = {
      ...state.linkedAccountForm,
      accounts: accounts
    }
  },
  deleteMasterPayer (state, id) {
    state.mPayers = state.mPayers.filter(account => account.Master_Id != id)
  },
  setLinkedAccountsReportGenerated (state, data) {
    state.linkedAccountsReportGenerated = data
  },
  setListOfCustomers (state, customers) {
    console.log('setListOfCustomers mutation called',customers)
    state.customers = customers
  }
}
